import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { useParams } from "react-router-dom";
import Blank from "../../components/DefaultStyles/Blank";
import ChildPageNav from "../../components/DefaultStyles/ChildPageNav";
import LineBox from "../../components/DefaultStyles/LineBox";
import PageTitle from "../../components/DefaultStyles/PageTitle";
import SpaceBetween from "../../components/DefaultStyles/SpaceBetween";
import TitleWithLine from "../../components/DefaultStyles/TitleWithLine";
import PartyDetailDefaultInfo from "../../components/pages/Party/PartyDetail/PartyDetailDefaultInfo";
import PartyDetailHeader from "../../components/pages/Party/PartyDetail/PartyDetailHeader";
import { Row } from "../Users/UserDetail";
import PartyDetailShareInfo from "../../components/pages/Party/PartyDetail/PartyDetailShareInfo";
import PartyDetailMemberInfo, {
  IPartyDetailMemberInfo,
} from "../../components/pages/Party/PartyDetail/PartyDetailMemberInfo";
import { useApi } from "../../hooks/useApi";
import PartyDetailMemberHistory from "../../components/pages/Party/PartyDetail/PartyDetailMemberHistory";
import PartyDetailPayInfo from "../../components/pages/Party/PartyDetail/PartyDetailPayInfo";
import Loader from "../../components/DefaultStyles/Loader";
import { useRecoilValue } from "recoil";
import { authType } from "../Login";
import PartyDetailComment from "../../components/pages/Party/PartyDetail/PartyDetailComment";
import LineBtn from "../../components/Button/LineBtn";
import MacroStateChangeModal from "../../components/pages/Party/PartyDetail/MacroStateChangeModal/MacroStateChangeModal";
import PartyDetailMemberHistoryRejoin from "../../components/pages/Party/PartyDetail/PartyDetailMemberHistoryRejoin";
import LinkidChatTable from "../../components/pages/Party/ChatInfo/ChatSearch/RecentChat/LinkidChatTable";
import RecentChatAll from "../../components/pages/Party/ChatInfo/RecentChatAll";
import RecentChatParty from "../../components/pages/Party/ChatInfo/RecentChatParty";

export default function PartyDetail() {
  const auth = useRecoilValue(authType);
  const { partyId } = useParams();

  const [ownerId, setOwnerId] = useState(0);
  const [macroStateChangeModal, setMacroStateChangeModal] = useState(false);
  const [member, setMember] = useState<{
    current: IPartyDetailMemberInfo[];
    ex: IPartyDetailMemberInfo[];
    rejoin: IPartyDetailMemberInfo[];
  }>({
    current: [],
    ex: [],
    rejoin: [],
  });

  const { response, fetchData, loading } = useApi({
    method: "get",
    url: auth?.partyInfo ? `party/${partyId}` : undefined,
  });

  const isUplusParty = response?.data?.servsubsid === 900001;
  const isNetflixExtra = response?.data?.servsubsid === 1100;

  useEffect(() => {
    if (response?.status === 200) {
      setOwnerId(Number(response.data.owner));
    }
  }, [response]);

  return (
    <>
      <SpaceBetween>
        <>
          <PageTitle title="파티 상세" route="/party/info" />

          <ChildPageNav parentRoute="/party/info" />
        </>
      </SpaceBetween>

      <PartyDetailHeader partyId={partyId} data={response?.data} />

      <Blank blankHeight={20} />

      {isUplusParty ? (
        <PartyDetailDefaultInfo
          data={response?.data}
          status={response?.status}
          fetchData={fetchData}
        />
      ) : (
        <Row>
          {/* 기본 정보 */}
          <Column>
            <PartyDetailDefaultInfo
              data={response?.data}
              status={response?.status}
              fetchData={fetchData}
            />
          </Column>

          {/* 공유 정보 */}
          <Column>
            <PartyDetailShareInfo
              data={response?.data}
              subsId={response?.data?.servsubsid ?? 0}
              status={response?.status}
              fetchData={fetchData}
            />
          </Column>
        </Row>
      )}

      <Blank blankHeight={20} />

      {/* 현재 인원 정보 */}
      <LineBox>
        <>
          <SpaceBetween>
            <TitleWithLine title="현재 인원 정보" />

            {isNetflixExtra ? (
              <LineBtn
                btnText="매크로 상태 변경"
                onClick={() => setMacroStateChangeModal(true)}
              />
            ) : (
              <></>
            )}
          </SpaceBetween>

          <Blank blankHeight={24} />

          <PartyDetailMemberInfo
            partyId={partyId}
            subsId={response?.data?.servsubsid ?? 0}
            data={response?.data}
            fetchData={fetchData}
            saveCurrentMember={(memberData: IPartyDetailMemberInfo[]) =>
              setMember((prev) => ({
                ...prev,
                current: memberData,
              }))
            }
          />
        </>
      </LineBox>

      <Blank blankHeight={20} />

      {/* 멤버 히스토리 */}
      <LineBox>
        <>
          <TitleWithLine title="멤버 히스토리" />

          <Blank blankHeight={24} />

          <PartyDetailMemberHistory
            partyId={partyId}
            subsId={response?.data?.servsubsid ?? 0}
            data={response?.data}
            ownerId={ownerId}
            saveExMember={(memberData: IPartyDetailMemberInfo[]) =>
              setMember((prev) => ({
                ...prev,
                ex: memberData,
              }))
            }
          />
        </>
      </LineBox>
      <Blank blankHeight={40} />

      {/* 멤버 재가입 히스토리 */}
      <LineBox>
        <>
          <TitleWithLine title="가입 이력 말소 히스토리" />

          <Blank blankHeight={24} />

          <PartyDetailMemberHistoryRejoin
            partyId={partyId}
            subsId={response?.data?.servsubsid ?? 0}
            data={response?.data}
            ownerId={ownerId}
            saveExRejoinMember={(memberData: IPartyDetailMemberInfo[]) =>
              setMember((prev) => ({
                ...prev,
                rejoin: memberData,
              }))
            }
          />
        </>
      </LineBox>

      <Blank blankHeight={40} />
      <LineBox>
        <>
          <TitleWithLine title="최근 파티 채팅" />

          <Blank blankHeight={24} />
          <RecentChatParty partyId={partyId} />
        </>
      </LineBox>
      <Blank blankHeight={40} />

      {/* 파티 코멘트  */}
      <PartyDetailComment partyId={partyId} ownerId={ownerId} />

      <Blank blankHeight={40} />

      {/* 결제/적립 정보 */}
      <PartyDetailPayInfo partyId={partyId} owner={response?.data?.owner} />

      {loading && <Loader />}

      {/* 넷플릭스 매크로 상태 변경 모달 */}
      {macroStateChangeModal && (
        <MacroStateChangeModal
          closeEvent={() => setMacroStateChangeModal(false)}
          memberData={member}
        />
      )}
    </>
  );
}

const Column = styled.div`
  min-height: 360px;
  &:first-child {
    width: 100%;
  }

  &:last-child {
    width: 100%;
  }
`;
